(function (window, document) {
  'use strict';

  const resultsActiveClass = 'js-repairs-autocomplete-results--active';
  const resultsVariantClass = '.repairs-autocomplete__variant';
  const resultsClass = '.js-repairs-autocomplete-results';
  const searchClass = '.js-search-standalone';
  const searchInputClass = '.repairs-autocomplete .js-search-standalone-input';
  const autocomplete = document.querySelector('.repairs-autocomplete');

  function handleSearchInputChange(e) {
    const body = document.querySelector('body');
    const results = e.target.closest(searchClass).nextElementSibling;
    const variants = results.querySelectorAll(resultsVariantClass);

    if (body) {
      body.addEventListener('click', handleBodyClick);
    }

    if (!results.classList.contains(resultsActiveClass) && variants.length > 0) {
      results.classList.add(resultsActiveClass);
    }
    else if (e.target.value === '' && body) {
      results.classList.remove(resultsActiveClass);
      body.removeEventListener('click', handleBodyClick);
    }
  }

  function handleBodyClick(e) {
    const body = document.querySelector('body');

    if (!e.target.closest(resultsVariantClass) && body) {
      const results = document.querySelector(resultsClass);

      results.classList.remove(resultsActiveClass);
      body.removeEventListener('click', handleBodyClick);
    }
  }

  function showError() {
    autocomplete.dataset.errorState = true;
  }

  function hideError() {
    autocomplete.dataset.errorState = false;
  }

  function init() {
    const searchInput = document.querySelector(searchInputClass);

    if (searchInput) {
      searchInput.addEventListener('input', handleSearchInputChange);
    }

    window.componentEvents.on('repairs-autocomplete-show-error', showError);
    window.componentEvents.on('repairs-autocomplete-hide-error', hideError);
  }

  init();

})(window, document);
